import { defineMessages } from 'react-intl'

const scope = `procurify.hooks.useFormatPunchOutStatus`

export default defineMessages({
  punchOutOrderCancelled: {
    id: `${scope}.punchOutOrderCancelled`,
    defaultMessage: 'Order Canceled',
  },
  punchOutPartiallyPurchased: {
    id: `${scope}.punchOutPartiallyPurchased`,
    defaultMessage: 'Partially Purchased',
  },
  punchOutBackordered: {
    id: `${scope}.punchOutBackordered`,
    defaultMessage: 'Backordered',
  },
})
